const newsletters = {
  cah: [
    {
      slug: "incendios-forestales",
      title:
        "Indicadores de la vegetación andina amazónica para la prevención de incendios forestales",
      tag: "Prevención de incendios forestales",
      active: true,
      content: () => [
        <p>
          El Boletín IGP – IVE / BI 2021 000,{" "}
          <b>
            de publicación mensual entre los meses de julio a diciembre de cada
            año
          </b>
          , tiene como objetivo difundir información de las condiciones
          favorables para la ocurrencia estacional de incendios en base al
          conocimiento científico desarrollado en el IGP con la ejecución de
          proyectos desarrollado en los últimos 10 en la institución. Es
          objetivo complementario mantener informados a los diferentes niveles
          de gobierno (nacional, regional y local) y proporcionarles
          herramientas para un uso óptimo de la información presentada, casi en
          tiempo real.
        </p>,
        <p>
          El estudio de los incendios forestales es aún, un desafío para la
          ciencia y el manejo forestal, debido a la interacción entre factores
          naturales y antrópicos (
          <a
            href="https://www.sciencedirect.com/science/article/abs/pii/S0378112713000388?via%3Dihub"
            target="_blank"
          >
            Lippok et a., 2013
          </a>
          ). En las últimas dos décadas los incendios forestales han impactado
          severamente en varias regiones del Perú, como Cajamarca, Cusco,
          Apurímac, Puno entre otros (
          <a
            href="https://repositorio.igp.gob.pe/handle/20.500.12816/4704"
            target="_blank"
          >
            Zubieta et al., 2019a
          </a>
          ;{" "}
          <a
            href="https://geoservidor.minam.gob.pe/monitoreo-y-evaluacion/registros-historicos-cfoi/"
            target="_blank"
          >
            MINAM, 2018
          </a>
          ). Las condiciones de sequía que se presentaron en la Amazonía y en
          los Andes peruanos durante los años 2005, 2010 y 2016 (
          <a
            href="https://agupubs.onlinelibrary.wiley.com/doi/full/10.1029/2011GL047862"
            target="_blank"
          >
            Espinoza et al., 2011
          </a>
          ;{" "}
          <a href="https://doi.org/10.1002/joc.4420" target="_blank">
            Marengo and Espinoza, 2016
          </a>
          ;{" "}
          <a href="https://doi.org/10.1002/joc.6453" target="_blank">
            Jiménez-Muñoz et al., 2019
          </a>
          ) coinciden con el incremento severo de la ocurrencia de incendios
          forestales en los Andes (
          <a
            href="http://repositorio.igp.gob.pe/handle/20.500.12816/4704"
            target="_blank"
          >
            Zubieta et al., 2019a
          </a>
          ). Asimismo, este incremento severo coincide con la disminución de las
          lluvias en los Andes que se presentan durante eventos de El Niño en el
          Pacífico central (
          <a
            href="http://dx.doi.org/10.1590/S0102-77862014000200003"
            target="_blank"
          >
            Lavado and Espinoza, 2014
          </a>
          ;{" "}
          <a
            href="https://adgeo.copernicus.org/articles/14/231/2008/adgeo-14-231-2008.html"
            target="_blank"
          >
            Lagos et al., 2008
          </a>
          ;{" "}
          <a
            href="https://adgeo.copernicus.org/articles/14/261/2008/"
            target="_blank"
          >
            Silva et al. 2008
          </a>
          ;{" "}
          <a href="https://doi.org/10.1002/joc.5185" target="_blank">
            Sulca et al., 2018
          </a>
          ).
        </p>,
        <p>
          A pesar de que el principal factor de la ocurrencia de incendios
          forestales en el Perú es asociada a las quemas llevadas a cabo por la
          población (
          <a
            href="https://www.serfor.gob.pe/portal/wp-content/uploads/2018/12/Plan-de-prevenci%C3%B3n-y-reducci%C3%B3n-de-riesgos-de-incendios-forestales.pdf"
            target="_blank"
          >
            SERFOR, 2018
          </a>
          ). El clima desempeña un rol fundamental debido a que este determina
          la facilidad de la ignición, su propagación y severidad (
          <a
            href="https://doi.org/10.1016/S1474-8177(08)00002-8"
            target="_blank"
          >
            Benson et al., 2009
          </a>
          ). Asimismo, están influenciados por factores biofísicos, como el
          desarrollo de la vegetación durante el periodo de estiaje.
        </p>,
        <p>
          Durante los últimos años, investigaciones del Instituto Geofísico del
          Perú (IGP) han documentado los impactos de la variabilidad climática
          en la cuenca amazónica, tal es el caso de las sequías (
          <a href="https://doi.org/10.1002/2016WR019305" target="_blank">
            Espinoza et al., 2016
          </a>
          ;{" "}
          <a href="https://doi.org/10.1002/joc.4420" target="_blank">
            Marengo y Espinoza, 2016
          </a>
          ) e incremento drástico de la ocurrencia de incendios en los Andes (
          <a
            href="http://repositorio.igp.gob.pe/handle/IGP/4704"
            target="_blank"
          >
            Zubieta et al., 2019a
          </a>
          ). En consecuencia, en apoyo a la gestión agroforestal y en el marco
          Programa Presupuestal por Resultados Nº 68 “Reducción de
          vulnerabilidad y atención de emergencias por desastres”, el IGP ha
          tomado la decisión de publicar el Boletín{" "}
          <b>
            “Indicadores de la vegetación andina amazónica para la prevención de
            incendios forestales”
          </b>
          , con el objetivo que la información que se proporciona sea de
          utilidad para la toma de decisiones para reducir el riesgo de
          desastres en el país.
        </p>,
      ],
      collectionId: "1543c61a-8b5c-47a0-987f-548cc351c440",
      prefix: "IGP–IVE / BI",
    },
    {
      slug: "valle-mantaro",
      title: "Eventos fríos y lluviosos en el valle de Mantaro",
      tag: "Valle de Mantaro",
      year: 2021,
      active: true,
      content: () => [
        <p>
          El Boletín IGP – MANTARO / BI 2021 000, es un boletín informativo
          sobre los eventos fríos y lluvias en el valle del Mantaro de{" "}
          <b>publicación mensual</b>, y describe los procesos físicos del porqué
          ocurren estos eventos, basado en el conocimiento científico y los
          datos generados en el IGP.
        </p>,
        <p>
          El proyecto de elaborar un Boletín sobre eventos fríos y lluvias en el
          valle del Mantaro surgió durante el último trimestre del año 2020,
          como resultado del proyecto Magnet “Fortalecimiento de la línea de
          investigación en física y microfísica de la atmósfera”, financiado por
          FONDECYT (CONCYTEC), ejecutado por el IGP entre los años 2017-2020; y
          el proyecto “Evaluación de Lluvias por radar y modelado de lluvias
          para alerta de Huaicos por Fuertes Lluvias en el Valle del Mantaro
          (Junín)“, financiado por el Fondo de Intervenciones ante Desastres y
          Emergencias (FONDES) y ejecutado por el IGP (2018-2020). El primer
          proyecto generó más de 20 publicaciones indexadas y el segundo se
          orienta más a resolver problemas locales, con la implementación de
          herramientas para los sistemas de alerta temprana y prevención de
          desastres en el valle del Mantaro. Siendo las lluvias uno de los
          parámetros más importante para prevenir desastres, el cual fue
          estudiado, y es monitoreado y modelado por el IGP, esta información se
          requiere compartir con las autoridades y el público en general.
        </p>,
        <h2>Evolución</h2>,
        <p>
          En el año 2015 el IGP inició el proyecto de equipamiento científico
          para laboratorios, con la adquisición del radar de nubes y
          precipitaciones MIRA 35C, financiado por Innóvate Perú. A partir de
          este año se obtuvieron datos de reflectividad que permitió estudiar la
          estructura vertical de las precipitaciones, distinguiendo los tipos de
          precipitación, su ciclo diurno y la variabilidad diaria, identificando
          las horas de máxima y mínima precipitación. La experiencia de este
          proyecto, permitió al IGP incursionar en el área de desarrollo
          tecnológico aplicado a la gestión de riesgo de desastres, con la
          construcción de otro radar perfilador de vientos y precipitación
          CLAIRE. Así mismo, es parte de estos proyectos la construcción de un
          radar en banda X que permitirá el monitoreo permanente de lluvias en
          un área de más de 100 km2
        </p>,
        <p>
          Durante los años 2017-2020 el IGP ha ejecutado el proyecto “Física y
          Microfísica de la Atmósfera” (Convenio Nº 010-2017/FONDECYT)
          financiado por FONDECYT del CONCYTEC. Con este proyecto, se generó
          conocimiento sobre los procesos físicos, microfísicos y dinámicos, que
          intervienen en la formación y variabilidad del clima y los eventos
          meteorológicos extremos en los Andes centrales, con énfasis en la
          cuenca del río Mantaro. Asimismo, se han generado herramientas que
          permiten el monitoreo y pronóstico de fenómenos adversos, como son las
          heladas, tormentas, lluvias intensas y veranillos. Esta información y
          herramientas, pueden ser útiles para la toma de decisiones de las
          entidades vinculadas a la agricultura, energía, transportes, etc.
        </p>,
        <p>
          Entre los años 2018 y 2020 se ejecutó el proyecto “Evaluación de
          Lluvias por radar y modelado de lluvias para alerta de Huaicos por
          fuertes lluvias en el valle del Mantaro (Junín)”, financiado por el
          Fondo de Intervenciones ante Desastres y Emergencias (FONDES) y
          ejecutado por el IGP (2018-2020). El proyecto permitió realizar
          campañas de observación sobre lluvias intensas, a la vez de evaluar
          los algoritmos de estimación de precipitación por radar y la
          implementación del modelo ARPS para el pronóstico de eventos adversos
          como tormentas y granizadas en el valle del Mantaro. Todos ellos han
          generado conocimiento que han sido publicados en prestigiosas revistas
          internacionales; sin embargo, ese conocimiento no ha sido aún puesta
          en formato ágil y entendible para los tomadores de decisiones. Por
          ello, se toma la decisión de elaborar un Boletín Informativo con
          información simplificada, que pueda ser comprensible y usada por las
          autoridades de la Región Junín.
        </p>,
        <h2>CORECC</h2>,
        <p>
          El IGP, como entidad científica, forma parte del Consejo Regional de
          Cambio Climático de la Región Junín–CORECC Junín, creada con Ordenanza
          Regional Nº 261-GRJ/CR del 23 de junio de 2017. El CORECC agrupa a
          instituciones públicas, privadas y de la sociedad civil, con la
          finalidad de promover la implementación de la Estrategia Regional de
          Cambio Climático de Junín, a través de propuestas de políticas,
          estrategias y planes para el desarrollo de medidas de mitigación y
          adaptación ante los efectos e impactos del cambio climático.
        </p>,
        <p>
          Finalmente, la información presentada en el boletín se sustenta en el
          número de publicaciones generada en los años recientes sobre el clima
          del Mantaro y las causas de su variabilidad y los eventos extremos que
          podrán ser consultados en{" "}
          <a href="https://repositorio.igp.gob.pe/" target="_blank">
            https://repositorio.igp.gob.pe/
          </a>
        </p>,
      ],
      collectionId: "8605f137-132c-4b41-9213-b850852ea835",
      prefix: "IGP – MANTARO / BI",
    },
    {
      slug: "el-nino",
      title: "El Niño",
      tag: "El Niño",
      year: 2021,
      active: true,
      content: () => [
        <p>
          Desde el 2014, el IGP y otras instituciones integrantes de la Comisión
          Multisectorial encargada del Estudio Nacional del Fenómeno “El Niño”
          (ENFEN) participan en el Programa Presupuestal 068:{" "}
          <b>
            "Reducción de la vulnerabilidad y atención de emergencias por
            desastres "
          </b>
          , contribuyendo con el producto denominado{" "}
          <b>
            " Entidades informadas de forma permanente y con pronósticos frente
            al fenómeno el Niño "
          </b>
          . En este sentido, el IGP realiza la síntesis y evaluación de los
          pronósticos de modelos climáticos internacionales, el desarrollo y
          validación de nuevos modelos, además de otros estudios que fortalecen
          en forma continua la capacidad de monitoreo y pronóstico de El Niño en
          el Perú.
        </p>,
        <p>
          En este contexto, el IGP a través del Programa de Investigación
          Ciencias de la Atmosfera e Hidrosfera (SCAH), genera conocimiento
          científico sobre los componentes del sistema climático (atmósfera,
          océano, suelo, biósfera y criósfera) y la interacción entre ellos. El
          Niño - Oscilación del Sur es uno de los principales modos de
          variabilidad, el cual es objeto de estudio debido a la alta
          vulnerabilidad del Perú y los impactos negativos asociados.
        </p>,
        <p>
          Asimismo, a fin de divulgar el conocimiento científico, el Instituto
          Geofísico del Perú - institución pública adscrita al Ministerio del
          Ambiente- presenta periódicamente sus investigaciones y avances en
          temas de variabilidad y cambio climático, a través de su Boletín
          Científico “El Niño”, tratando de presentar información en un lenguaje
          sencillo y sintetizando los aspectos más relevantes de dichas
          investigaciones. El objetivo es que las autoridades y técnicos
          especialistas en la gestión del riesgo de desastres (GRD)
          pertenecientes a los tres niveles de gobierno, así como el público en
          general interesado, puedan tener como fuente de conocimiento a los
          materiales de investigación que el IGP genera.
        </p>,
      ],
      collectionId: "407b0b37-7d65-4ecb-a960-1928001a30f3",
      prefix: "Boletín El Niño",
    },
  ],
};

function getNewsletters(program_id) {
  return newsletters[program_id] || newsletters["cah"];
}

export { getNewsletters };
